// Marketing context that asi-next forwards to the ASI variant of this form
// via URL query params. Read once at first access and cache module-level so
// later Vue navigations (TravelData → UserData) still see it even if the
// router cleared the query string in the meantime.
//
// `lp_position` is read from `utm_content` (asi-next encodes it there so
// GA4's cross-domain linker picks it up automatically as a dimension); we
// surface it under a clearer name for our custom GTM events. `touchpoint`
// and `asi_path` aren't covered by GA4's auto-set, so asi-next forwards
// them as explicit query params.
let cached;

export function getMarketingContext() {
    if (cached !== undefined) return cached;
    if (typeof window === 'undefined') return {};

    const params = new URLSearchParams(window.location.search);
    cached = {
        lp_position: params.get('utm_content') || undefined,
        touchpoint: params.get('touchpoint') || undefined,
        asi_path: params.get('asi_path') || undefined,
    };
    return cached;
}
